import React, { useEffect, useState } from "react";
import axios from "axios";
import * as Constants from "../../constants/urls";
import { useCookies } from "react-cookie";
import Loading from "../Loading/Loading";
import SmsTemplateModal from "./SmsTemplateModal";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Pagination from "react-js-pagination";

export default function SmsTemplate() {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [editItem, setEditItem] = useState();

  const [cookies, setCookie, removeCookie] = useCookies();
  function getData(page = 1) {
    setLoading(true);

    const url = Constants.apiUrl + "/api/sms/template?page=" + page;
    axios
      .get(url, {
        headers: {
          Authorization: "Bearer " + cookies.user_server_token,
        },
      })
      .then((r) => {
        setData(r.data.data);
        setLoading(false);

        console.log(r);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Breadcrumb title={"مدیریت الگوی پیامک  "} />
      {loading && <Loading />}
      {modal && (
        <SmsTemplateModal
          close={() => {
            setModal(false);
            getData();
          }}
          item={editItem}
        />
      )}

      <div
        className="d-flex flex-warp mt-4 mr-3"
        style={{ direction: "rtl", gap: "10px" }}
      > 
        <span class="badge badge-success"> نام متغیر ها</span>
        <span class="badge badge-warning">{"{{name}}"}</span>
        <span class="badge badge-warning">{"{{code}}"}</span>
        <span class="badge badge-warning">{"{{prodName}}"}</span>
        <span class="badge badge-warning">{"{{url}}"}</span>
      </div>

      <div className="table-responsive mt-5 mb-5">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <td>شناسه</td>
              <td> نام </td>
              <td> وضعیت </td>
              <td> ویرایش </td>
            </tr>
          </thead>
          {data &&
            data.data &&
            data.data.map((item) => {
              return (
                <tr>
                  <td>{item.id}</td>
                  <td>{item.name}</td>
                  <td>{item.status ? "فعال" : "غیر فعال"}</td>
                  <td>
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        setEditItem(item);
                        setModal(true);
                      }}
                    >
                      ویرایش
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>

        <button
          className="btn btn-primary btn-block"
          onClick={() => {
            setEditItem(undefined);
            setModal(true);
          }}
        >
          افزودن
        </button>
        {data && (
          <div className="pager Page navigation example">
            <Pagination
              totalItemsCount={data.total}
              activePage={data.current_page}
              itemsCountPerPage={data.per_page}
              onChange={(number) => {
                getData(number);
              }}
              itemClass="page-item"
              linkClass="page-link"
              firstPageText="اولین صفحه"
              lastPageText="آخرین صفحه"
              nextPageText="بعدی"
              prevPageText="قبلی"
              activeClass="pageactive"
            />
          </div>
        )}
      </div>
    </>
  );
}
